import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SessionStorageService } from 'src/app/services/session-storage.service';
import { LoggingMessageService } from 'src/app/services/logging-message.service';
import { environment } from 'src/environments/environment';
import { UserNavigationService } from 'src/app/services/user-navigation.service';
import { AuthService } from 'src/app/services/auth.service';
import { DomSanitizer } from '@angular/platform-browser';
import { WindowEventsService } from 'src/app/services/window-events.service';
import { IframeService } from 'src/app/services/iframe.service';
import { BaseWebsiteComponent } from '../base-website/base-website.component';
import { PendoService } from 'src/app/services/pendo.service';
import { SubscriptionChangeService } from 'src/app/services/subscription-change.service';

@Component({
    standalone: true,
    selector: 'app-ndnqi-foundation',
    templateUrl: './ndnqi-foundation.component.html'
})

export class NdnqiFoundationComponent
    extends BaseWebsiteComponent
    implements OnInit, OnDestroy {

    constructor(
        public router: Router,
        public route: ActivatedRoute,
        public logger: LoggingMessageService,
        public navigationService: UserNavigationService,
        public sessionService: SessionStorageService,
        public authService: AuthService,
        public windowEvents: WindowEventsService,
        public pendoService: PendoService,
        public iframeService: IframeService,
        public sanitizer: DomSanitizer,
        public subscriptionService: SubscriptionChangeService) {
        super(router, route, logger, sessionService, navigationService, authService, windowEvents, iframeService, pendoService, sanitizer, subscriptionService);
    }

    ngOnInit() {
        this.reqestSizeFromIFrame();
        super.ngOnInit();
        this.selectedSubscriptionID = this.subscriptionService.SelectedSubscription;
        this.availableSubscriptions = this.subscriptionService.AvailableSubscriptionsString;
    }

    subscribeToChildSiteEvents() {
        this.subscribeSubDomainActionEvents();

        const addSubscription = this.iframeService.ndnqiFoundationFrameLoaded$
            .subscribe(v => this.reqestSizeFromIFrame());
        this.$subscriptions.add(addSubscription);
    }

    getIframeReferences() {
        if (!this.visibleIframe) {
            this.visibleIframe = document.getElementById('appNdnqiFoundationIFrame') as HTMLIFrameElement;
        }
    }

    loadIframe(path: string) {
        const isLoggedIn = this.authService.isUserLoggedIn();
        if (isLoggedIn === true) {
            const displayedMenu = this.navigationService.DisplayedNavigationMenu;
            if (displayedMenu && displayedMenu.Items && displayedMenu.Items.length > 0) {
                this.updatePendo();
                this.setIframeSource(path);
                this.iframeService.setNdnqiFoundationFrameVisibility(true);
                this.iframeService.setLinkId('');
            } else {
                this.router.navigated = false;
            }
        }
    }

    setIframeSource(path: string) {
        const iframe = document.getElementById('appNdnqiFoundationIFrame') as HTMLIFrameElement;
        if (iframe) {
            path = path.replace('/if', '');
            path = path.replace('/ndnqifoundation/', '');
            if (path.startsWith('/')) {
                path = path.substring(1, path.length - 1);
            }
            this.logger.debug('ndnqi-foundation', 'setIframeSource', this.selectedSubscriptionID, this.availableSubscriptions, `Src: ${path}`, '');
            this.currentUrl = path;
            this.iframeService.setNdnqiFoundationFrameSource(path);
            this.navigationService.emitNavigationComplete(this.linkid);
        }
    }

    updateIframeHeight(data: any) {
        const iframe = this.visibleIframe;
        if (iframe) {
            const height = parseFloat(data);
            if (height > 1000) {
                iframe.style.height = (height + 100) + 'px';
                this.logger.debug('ndnqi-foundation', 'updateIframeHeight', this.selectedSubscriptionID, this.availableSubscriptions, `Setting IFrame height to ${data}`, '');
            } else {
                iframe.style.height = '1000px';
            }
        }
    }

    goBack() {
        const url = this.previousUrl;
        if (url) {
            this.loadIframe(url.replace(environment.WebServer, ''));
        }
    }

    ngOnDestroy(): void {
        this.visibleIframe = null;
        this.iframeService.setNdnqiFoundationFrameVisibility(false);
        super.ngOnDestroy();
    }
}
